import { render, staticRenderFns } from "./BillingAutopayCards.vue?vue&type=template&id=5065df5b"
import script from "./BillingAutopayCards.vue?vue&type=script&lang=js"
export * from "./BillingAutopayCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports